import type { QueryClient } from '@tanstack/react-query';
import { EndpointReads, type EntityTag } from '@signalvote/shared';

/** A GET the API declares `[Reads]` on, as `'GET <route template>'` with no query string. */
export type ReadEndpoint = keyof typeof EndpointReads;

export interface ReadsMeta extends Record<string, unknown> {
  reads: readonly EntityTag[];
}

/** The query `meta` that lets a write naming one of the endpoint's entity types refresh it. */
export function readsMeta(endpoint: ReadEndpoint): ReadsMeta {
  return { reads: EndpointReads[endpoint] };
}

function declaredReads(meta: Record<string, unknown> | undefined): readonly EntityTag[] | undefined {
  return meta?.reads as readonly EntityTag[] | undefined;
}

/**
 * Invalidates every query whose declared reads include one of `writes`, the entity types a
 * response's `X-SV-Writes` names. Active ones refetch; the rest (another campaign's, an unmounted
 * screen's) go stale and refetch when next observed. A query without declared reads is untouched.
 */
export function invalidateWrites(client: QueryClient, writes: readonly EntityTag[]): Promise<void> {
  if (writes.length === 0) return Promise.resolve();
  const written = new Set<EntityTag>(writes);
  return client.invalidateQueries({
    predicate: (query) => declaredReads(query.meta)?.some((tag) => written.has(tag)) ?? false,
  });
}
